import React from "react";

import Result from "./Result";

function Results({ results, openPopup }) {
  if (results) {
    return (

      <section className="results">
        {results.map(result => (
          <Result key={result.imdbID} result={result} openPopup={openPopup} />
        ))}
      </section>
    );

  } else {
    return (

      <section className="results">
        <h1>No Movies found, sry 🎥 </h1>
      </section>
    );
  }

}

export default Results;
